import * as yup from 'yup';

/** A SAR amount above 0, typed into a number field (the field holds a string; the check reads it as a number). */
export const amountSchema = yup
  .number()
  .typeError('Enter an amount above 0')
  .moreThan(0, 'Enter an amount above 0')
  .required('Amount is required');
